import * as React from 'react';
import { IconProps } from './IconProps';

export default function SadFaceIcon(props: IconProps) {
    return (
        <svg { ...props } fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    );
}
